import types from '../../types';

export default {
  [types.STORE_NEWS]: (state, payload) => {
    state.news = {
      items: [...state.news.items, ...payload.items],
      count: payload.count,
      pages: payload.pages,
      entity: payload.entity,
    };
  },
  [types.CLEAR_NEWS]: (state) => {
    state.news = {
      items: [],
      count: '',
      pages: 0,
      entity: {},
    };
  },
  [types.MARK_NEWS_ITEM_READ]: (state, newsId) => {
    const item = state.news.items.find(n => n.id === newsId);
    if (item && !item.is_read) {
      item.is_read = true;
      if (state.news.entity && state.news.entity.total_unread > 0) {
        state.news.entity.total_unread -= 1;
      }
    }
  },
};
